import React, { useState } from "react";
import { PaystackButton } from "react-paystack";
import CheckoutDropdown from "./CheckoutDropdown";
import PaymentSuccessfulIcon from "../assets/icons/paymentsuccessful.svg";

const CheckoutForm = ({ productName, productQuantity, amount }) => {
  const publicKey = process.env.REACT_APP_PAYSTACK_PUBLIC_KEY;
  const [customerName, setCustomerName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [deliveryOption, setDeliveryOption] = useState("");
  const [inputAddress, setInputAddress] = useState("");
  const [paymentSuccessful, setPaymentSuccessful] = useState(false);

  const handleDeliveryOption = (e) => {
    setDeliveryOption(e.target.value);
  };

  console.log(inputAddress);

  const componentProps = {
    email,
    amount: `${amount}00`,
    metadata: {
      customerName,
      phone,
      productName,
      productQuantity,
      deliveryOption,
      inputAddress,
    },
    publicKey,
    text: "Pay",
    onSuccess: () => {
      setPaymentSuccessful(true);
    },
  };

  return (
    <div className="checkout bg-white pt-8  rounded-lg myShadow">
      <div className={`checkout-form px-8 ${paymentSuccessful && `hidden`}`}>
        <div className="mt-10 checkout-field">
          <label htmlFor="fullName" class="block mb-2 text-sm font-bold ">
            Your Name
          </label>
          <input
            type="text"
            id="name"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
            placeholder="Your Name"
            onChange={(e) => setCustomerName(e.target.value)}
            required
          />
        </div>
        <div className="mt-10 checkout-field">
          <label htmlFor="email" class="block mb-2 text-sm font-bold ">
            Your Email
          </label>
          <input
            type="email"
            id="email"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
            placeholder="Your Email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="mt-10 checkout-field">
          <label htmlFor="phone" class="block mb-2 text-sm font-bold ">
            Your Phone Number
          </label>
          <input
            type="text"
            id="phone"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
            placeholder="Your Phone Number"
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </div>
        <div className="mt-10 checkout-field">
          <label htmlFor="first_name" class="block mb-2 text-sm font-bold ">
            Product Name
          </label>
          <input
            type="text"
            id="product_name"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md cursor-not-allowed focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
            placeholder="Your Email"
            value={productName}
            required
            disabled
          />
        </div>
        <div className="mt-10 checkout-field flex justify-between gap-4">
          <div>
            <label htmlFor="first_name" class="block mb-2 text-sm font-bold ">
              Quantity
            </label>
            <input
              type="number"
              id="quantity"
              className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md cursor-not-allowed focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
              placeholder="Quantity"
              value={productQuantity}
              required
              disabled
            />
          </div>
          <div>
            <label htmlFor="first_name" class="block mb-2 text-sm font-bold ">
              Amount
            </label>
            <input
              type="number"
              id="amount"
              className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md cursor-not-allowed focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
              placeholder="Quantity"
              value={amount}
              required
              disabled
            />
          </div>
        </div>
        <div className="mt-10 checkout-field">
          <CheckoutDropdown onChange={handleDeliveryOption} />
        </div>

        <div
          className={`mt-10 checkout-field ${
            deliveryOption === "other" ? `block` : `hidden`
          }`}
        >
          <label htmlFor="first_name" class="block mb-2 text-sm font-bold ">
            Delivery Address
          </label>
          <input
            type="text"
            id="delivery_address"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md  focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
            placeholder="Your Delivery Address"
            onChange={(e) => setInputAddress(e.target.value)}
          />
          <p className="text-xs mt-1 text-gray-500">
            PS: We'll contact you regarding the payment for delivery. Thank you.
          </p>
        </div>

        <div className="mt-10">
          <PaystackButton
            className="paystack-button bg-dark-blue rounded-md px-4 py-2.5 md:px-8 md:py-4 text-white"
            {...componentProps}
          />
        </div>
      </div>
      {/* Payment Confirmation Kini */}
      <div
        className={`flex flex-col justify-center items-center px-8 ${
          !paymentSuccessful && `hidden`
        }`}
      >
        <div>
          <img
            src={PaymentSuccessfulIcon}
            alt="Payment Successful Icon"
            className="w-24 h-24"
          />
        </div>
        <div className="mt-4 text-center">
          <h3 className="text-3xl">Payment Successful</h3>
          <p className="mt-4">
            Thank you for shopping with us. We hope you love the product. We are
            eager to hear your review.
          </p>
        </div>
        <div className="mt-4">
          <table className="border-collapse border border-spacing-2 border-slate-400 w-full">
            <tbody>
              <tr>
                <td className="border border-slate-300 p-2">Item</td>
                <td className="border border-slate-300 p-2">{productName}</td>
              </tr>
              <tr>
                <td className="border border-slate-300 p-2">Quantity</td>
                <td className="border border-slate-300 p-2">
                  {productQuantity}
                </td>
              </tr>
              <tr>
                <td className="border border-slate-300 p-2">Amount Paid</td>
                <td className="border border-slate-300 p-2">{amount}</td>
              </tr>
              <tr>
                <td className="border border-slate-300 p-2">Email</td>
                <td className="border border-slate-300 p-2">{email}</td>
              </tr>
              <tr>
                <td className="border border-slate-300 p-2">Customer Name</td>
                <td className="border border-slate-300 p-2">{customerName}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="h-1 bg-gray-700 rounded-lg w-full mt-8">.</div>
    </div>
  );
};

export default CheckoutForm;
